import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties(
	'CREATE_XTEL_TRACKER',
	'GET_XTEL_TRACKER',
	'UPDATE_XTEL_TRACKER_ID',
	'DELETE_XTEL_TRACKER',
	'GET_XTEL_TRACKERS'
);
